import { Box } from '@mui/material';
export default function StepContainer({ children, sx = {} }) {
  return (
    <Box minHeight={450}>
      <Box sx={{ mt: 2, mb: 1, py: 1, px: 4, ...sx }}>{children}</Box>
    </Box>
  );
}
